export const getUserQuery = (email) => `query {
  users: getUsers(email: "${email}") {
    _id
    email
    name
    role
    linkId
  }
}`;

export const materialQuery = () => `query {
  materials {
    _id
    model
    description
    company
    address
    density
    thickness
    rValue
    nails
  }
}`;

export const materialWithCarbonQuery = () => `query {
  materials: materialsWithCarbon {
    _id
    model
    description
    company
    address
    density
    thickness
    rValue
    nails
    validity
    type
    expiration
    lifeCycle
    database
    impactCharacteristics
    url
    pcr
    woodHumidity
    a1a3
    a4
    a5
    b1b7
    c2
    c4
    total
  }
}`;

export const getManufacturerQuery = () => `query ExampleQuery($getManufacturerId: ID) {
  getManufacturer(id: $getManufacturerId) {
    _id
    companyInfo {
      name
      address {
        street
        city
        province
        postalCode
        country
      }
      phone
      fax
      email
      website
      registrationNumber
    }
    accountsPayable {
      contactName
      contactEmail
      contactPhone
    }
  }
}`;

const LOCATION_FIELDS = `{
  _id
  manufacturerId
  name
  description
  yardArea
  address {
    street
    city
    province
    postalCode
    country
  }
}`;

export const getLocationsQuery = () => `query GetLocations($manufacturerId: ID!) {
  locations: getLocations(manufacturerId: $manufacturerId) ${LOCATION_FIELDS}
}`;

const FACILITY_FIELDS = `{
  _id
  locationId
  name
  description
  type
}`;

export const getFacilitiesQuery = () => `query GetFacilities($locationId: ID!) {
  facilities: getFacilities(locationId: $locationId) ${FACILITY_FIELDS}
}`;

const USER_FIELDS = `{
  _id
  name
  email
  role
  linkId
}`;

export const getUsersQuery = () => `query GetUsers($email: String) {
  users: getUsers(email: $email) ${USER_FIELDS}
}`;

const PROJECT_FIELDS = `{
  _id
  projectId
  projectLang
  projectInfo {
    name
    number
    description
    clientName
    constructionStartDate
    location {
      postalCode
      street
      number
      city
      province
      country
    }
  }
  panelCountEstimator {
    panelConfiguration {
      maxPanelWidth
      maxPanelLength
    }
    selectedWalls {
      wallType
      width
      totalArea
      totalLength
    }
    prefabricatedWallType
    panelEstimation {
      completePanels
      irregularPanels
      numberOfTrucks
      truckDimensions {
        length
        width
        height
      }
      spacerThickness
    }
  }
  carbonImpactEstimator {
    materialtotals {
      area
      volume
      mass
      carbonFootprint
    }
  }
  bracing {
    minimumLength {
      northSouth
      eastWest
    }
    validatedWalls {
      _id
      name
      shearNumber
      orientation
      length
      type
    }
    missingLength {
      northSouth
      eastWest
    }
  }
}`;

export const getProjectByIdQuery = () => `query GetProject($projectId: String!) {
  project: getProject(projectId: $projectId) ${PROJECT_FIELDS}
}`;

